<main class="default_component_structure">
  <app-filtros 
    class="default_component_structure__filtros" 
    [filtros]="filtros" 
    [acoes]="acoes" 
    (onSearch)="filtrar($event)">
  </app-filtros>

  <section class="default_component_structure__content">
    <div class="default_component_structure__content__wrapper">
      <app-table [colunas]="colunas" [items]="items"></app-table>
    </div>
    <mat-paginator 
      showFirstLastButtons 
      class="faturamento__content__paginator" 
      [length]="paginationOptions.length" 
      [pageSize]="paginationOptions.pageSize">
    </mat-paginator>
  </section>
</main>
